// UI domain - React application entry point and DOM initialization

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./ui.components";
import "../client";

if (typeof window !== "undefined") {
  const originalConsoleError = console.error;
  console.error = (...args: unknown[]) => {
    const message = args.join(" ");

    if (process.env.NODE_ENV === "production") {
      if (
        message.includes("chrome-extension://") ||
        message.includes("Script error") ||
        message.includes("ResizeObserver loop limit exceeded") ||
        message.includes("Non-Error promise rejection")
      ) {
        return;
      }
    }

    originalConsoleError.apply(console, args);
  };

  window.addEventListener("error", (event) => {
    const message = event.message || "";

    if (
      message.includes("chrome-extension://") ||
      event.filename?.includes("chrome-extension://") ||
      message.includes("Script error") ||
      message.includes("ResizeObserver loop limit exceeded")
    ) {
      event.preventDefault();
      return;
    }
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    const message = reason?.message || reason?.toString() || "";

    if (
      message.includes("chrome-extension://") ||
      message.includes("Script error") ||
      message.includes("ResizeObserver loop limit exceeded")
    ) {
      event.preventDefault();
      return;
    }
  });
}

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

if (import.meta.hot) {
  import.meta.hot.data.root ??= createRoot(elem);
  const root = import.meta.hot.data.root;
  root.render(app);
} else {
  createRoot(elem).render(app);
}
